<template>
  <div>

    <div v-if="cargando" style="text-align:center; padding:2rem; color:#8898aa; font-size:14px;">
      Cargando...
    </div>

    <template v-else>
      <div style="background:#fff; border:1px solid #e9ecef; border-radius:12px; padding:16px 20px; margin-bottom:16px; overflow-x:auto;">
        <p style="font-size:12px; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:#8898aa; margin-bottom:12px;">
          Intervenciones activas
        </p>

        <div v-if="!tieneActivas" style="font-size:13px; color:#8898aa;">
          No tienes intervenciones activas.
        </div>

        <table v-else style="width:100%; border-collapse:collapse; font-size:13px;">
          <thead>
            <tr style="text-align:left; color:#8898aa; border-bottom:1px solid #e9ecef;">
              <th style="padding:8px 6px; font-weight:600;">Tipo</th>
              <th style="padding:8px 6px; font-weight:600;">Estado</th>
              <th style="padding:8px 6px; font-weight:600;">Instancia</th>
              <th style="padding:8px 6px; font-weight:600;">Fecha inicio</th>
              <th style="padding:8px 6px; font-weight:600;">Inst. 1</th>
              <th style="padding:8px 6px; font-weight:600;">Inst. 2</th>
              <th style="padding:8px 6px; font-weight:600;">Inst. 3</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="intervencion in intervenciones.activas" :key="intervencion.id" style="border-bottom:1px solid #f6f9fc;">
              <td style="padding:10px 6px;">
                <span style="font-size:11px; font-weight:700; padding:3px 10px; border-radius:20px; background:#e6e0fb; color:#5e35b1;">
                  {{ intervencion.tipo === 'franquicias' ? 'Franquicias' : 'Daily' }}
                </span>
              </td>
              <td style="padding:10px 6px;">
                <span style="font-size:11px; font-weight:700; padding:3px 10px; border-radius:20px; background:#ffeaea; color:#c0002a;">activo</span>
              </td>
              <td style="padding:10px 6px; color:#32325d;">{{ intervencion.instancia_actual }} de 3</td>
              <td style="padding:10px 6px; color:#525f7f;">{{ formatFecha(intervencion.fecha_inicio) }}</td>
              <td style="padding:10px 6px;">
                <a v-if="intervencion.auditoria_1_id" href="#" @click.prevent="verAuditoria(intervencion.auditoria_1_id)" style="color:#27884d; font-weight:600; font-size:12px;">VER DETALLE</a>
                <span v-else style="color:#adb5bd;">—</span>
              </td>
              <td style="padding:10px 6px;">
                <a v-if="intervencion.auditoria_2_id" href="#" @click.prevent="verAuditoria(intervencion.auditoria_2_id)" style="color:#27884d; font-weight:600; font-size:12px;">VER DETALLE</a>
                <span v-else style="color:#adb5bd;">—</span>
              </td>
              <td style="padding:10px 6px;">
                <a v-if="intervencion.auditoria_3_id" href="#" @click.prevent="verAuditoria(intervencion.auditoria_3_id)" style="color:#27884d; font-weight:600; font-size:12px;">VER DETALLE</a>
                <span v-else style="color:#adb5bd;">—</span>
              </td>
            </tr>
          </tbody>
        </table>

        <div style="display:flex; flex-direction:column; gap:8px; margin-top:14px;">
          <div
            v-for="intervencion in intervenciones.activas"
            :key="'cons-' + intervencion.id"
          >
            <div v-if="(intervencion.consecuencias_aplicadas || []).length" style="display:flex; gap:6px; flex-wrap:wrap;">
              <span
                v-for="c in intervencion.consecuencias_aplicadas"
                :key="c"
                style="font-size:11px; font-weight:600; padding:3px 10px; border-radius:20px; background:#ffeaea; color:#c0002a;"
              >{{ consecuenciaLabel(c) }}</span>
            </div>
          </div>
        </div>
      </div>

      <div style="background:#fff; border:1px solid #e9ecef; border-radius:12px; padding:16px 20px; overflow-x:auto;">
        <p style="font-size:12px; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:#8898aa; margin-bottom:12px;">
          Historial de intervenciones
        </p>

        <div v-if="intervenciones.historial.length" style="display:flex; gap:16px; flex-wrap:wrap; margin-bottom:14px;">
          <div style="display:flex; gap:6px; flex-wrap:wrap;">
            <button
              v-for="opcion in filtrosTipo"
              :key="'tipo-' + opcion.valor"
              @click="tipoActivo = opcion.valor"
              :style="chipStyle(tipoActivo === opcion.valor)"
            >{{ opcion.label }}</button>
          </div>
          <div style="display:flex; gap:6px; flex-wrap:wrap;">
            <button
              v-for="opcion in filtrosEstado"
              :key="'estado-' + opcion.valor"
              @click="estadoActivo = opcion.valor"
              :style="chipStyle(estadoActivo === opcion.valor)"
            >{{ opcion.label }}</button>
          </div>
        </div>

        <div v-if="!intervenciones.historial.length" style="font-size:13px; color:#8898aa;">
          Sin historial de intervenciones registrado.
        </div>
        <div v-else-if="!historialFiltrado.length" style="font-size:13px; color:#8898aa;">
          No hay intervenciones que coincidan con el filtro.
        </div>
        <table v-else style="width:100%; border-collapse:collapse; font-size:13px;">
          <thead>
            <tr style="text-align:left; color:#8898aa; border-bottom:1px solid #e9ecef;">
              <th style="padding:8px 6px; font-weight:600;">Tipo</th>
              <th style="padding:8px 6px; font-weight:600;">Estado</th>
              <th style="padding:8px 6px; font-weight:600;">Instancia cierre</th>
              <th style="padding:8px 6px; font-weight:600;">Fecha inicio</th>
              <th style="padding:8px 6px; font-weight:600;">Fecha cierre</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="h in historialFiltrado" :key="h.id" style="border-bottom:1px solid #f6f9fc;">
              <td style="padding:10px 6px;">
                <span style="font-size:11px; font-weight:700; padding:3px 10px; border-radius:20px; background:#e6e0fb; color:#5e35b1;">
                  {{ h.tipo === 'franquicias' ? 'Franquicias' : 'Daily' }}
                </span>
              </td>
              <td style="padding:10px 6px;">
                <span
                  style="font-size:11px; font-weight:700; padding:3px 10px; border-radius:20px;"
                  :style="h.estado === 'recuperado' ? 'background:#e6f5ec; color:#27884d;' : 'background:#e6f0fb; color:#185fa5;'"
                >{{ h.estado }}</span>
              </td>
              <td style="padding:10px 6px; color:#32325d;">{{ h.instancia_cierre }}</td>
              <td style="padding:10px 6px; color:#525f7f;">{{ formatFecha(h.fecha_inicio) }}</td>
              <td style="padding:10px 6px; color:#525f7f;">{{ formatFecha(h.fecha_cierre) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

  </div>
</template>

<script>
const CONSECUENCIA_LABELS = {
  foodcourt_cerrado: 'Foodcourt cerrado',
  daily_reducido: 'Daily reducido',
  platos_reducidos: 'Platos reducidos',
  pausar_servicio: 'Servicio pausado',
  cerrar_contrato: 'Contrato en cierre'
}

export default {
  name: 'CardIntervenciones',
  props: {
    intervenciones: { type: Object, required: true },
    cargando: { type: Boolean, default: false }
  },
  data () {
    return {
      tipoActivo: 'todas',
      estadoActivo: 'todos',
      filtrosTipo: [
        { valor: 'todas', label: 'Todas' },
        { valor: 'daily', label: 'Daily' },
        { valor: 'franquicias', label: 'Franquicia' }
      ],
      filtrosEstado: [
        { valor: 'todos', label: 'Todos' },
        { valor: 'recuperado', label: 'Recuperado' },
        { valor: 'resuelto', label: 'Resuelto' }
      ]
    }
  },
  computed: {
    tieneActivas () {
      return (this.intervenciones.activas || []).length > 0
    },
    historialFiltrado () {
      var lista = this.intervenciones.historial || []
      if (this.tipoActivo !== 'todas') {
        lista = lista.filter(function (h) { return h.tipo === this.tipoActivo }, this)
      }
      if (this.estadoActivo !== 'todos') {
        lista = lista.filter(function (h) { return h.estado === this.estadoActivo }, this)
      }
      return lista
    }
  },
  methods: {
    consecuenciaLabel (c) {
      return CONSECUENCIA_LABELS[c] || c
    },
    verAuditoria (id) {
      this.$router.push({ name: 'auditorias-detalle', params: { id: id } })
    },
    formatFecha (fecha) {
      if (!fecha) return ''
      var d = new Date(fecha.indexOf('T') === -1 ? fecha + 'T00:00:00' : fecha)
      if (isNaN(d.getTime())) return fecha
      var months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
      return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear()
    },
    chipStyle (activo) {
      return {
        fontSize: '12px',
        fontWeight: '600',
        padding: '4px 12px',
        borderRadius: '20px',
        border: activo ? '1px solid #27884d' : '1px solid #e9ecef',
        background: activo ? '#e6f5ec' : '#fff',
        color: activo ? '#27884d' : '#8898aa',
        cursor: 'pointer'
      }
    }
  }
}
</script>
